var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.0625 17.561C13.7569 17.561 17.5625 13.7555 17.5625 9.06104C17.5625 4.36661 13.7569 0.561035 9.0625 0.561035C4.36808 0.561035 0.5625 4.36661 0.5625 9.06104C0.5625 13.7555 4.36808 17.561 9.0625 17.561Z",
    stroke: "#404040",
    strokeWidth: 1.12185
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5625 8.56104H8.84028C8.76661 8.56104 8.69595 8.53093 8.64386 8.47735C8.59177 8.42377 8.5625 8.3511 8.5625 8.27532V4.56104",
    stroke: "#404040",
    strokeWidth: 1.12185,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIcon);
export default __webpack_public_path__ + "static/media/clock_icon.0b4d2affa9d0f8a60c4fe5a510d8446e.svg";
export { ForwardRef as ReactComponent };